import styled, { css } from 'styled-components';

// Styles
import { hoverCapable } from '../../../../../../styles/hover';

// ✅ Usar sistema de temas - siguiendo patrón MainButton

// Styled Components
import { Container } from '../../../summaryTables/SummaryTablesStyles';
import { Tr } from '../../../components/MainStyledComponents';

export const TableContainer = styled.div`
  width: 100%;
  height: 20.8rem;
  overflow: auto;
  background-color: ${({ theme }) => theme.colors.greyVerySoft};
`;

export const ContainerTable = styled(Container)`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  width: 100%;
`;

export const ActiveBudgetItemsTableContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2.8rem;
  width: 100%;
`;

export const InactiveBudgetItemsTableContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2.8rem;
  width: 100%;
`;

export const BudgetItemsTableContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 2.8rem;
  width: 100%;
`;

export const FiltersContainer = styled.div`
  display: flex;
  align-items: end;
  gap: ${({ theme }) => theme.spacing.m};
  div:last-child {
    flex: 1;
  }
`;

export const TrStyled = styled(Tr)`
  background-color: ${(props) => props.checked && props.theme.colors.lightRed};
  ${({ indeterminate, checked }) => css`
    Td {
      ${!indeterminate && {
        opacity: 0.2,
      }}
      ${checked && {
        opacity: 1,
      }}
    }
  `}
`;

export const CategoryBadge = styled.div<{ color: string }>`
  display: inline-flex;
  align-items: center;
  padding: ${({ theme }) => theme.spacing.xxxs}
    ${({ theme }) => theme.spacing.xs};
  border-radius: ${({ theme }) => theme.borderRadius.sm};
  background-color: ${({ color }) => color}20;
  border: 1px solid ${({ color }) => color};

  &::before {
    content: '';
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: ${({ color }) => color};
    margin-right: 0.5rem;
  }
`;

export const PriceCell = styled.div`
  font-weight: ${({ theme }) => theme.fontWeight.semiBold};
  color: ${({ theme }) => theme.colors.green};
`;

export const SwapButtonsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  padding: 1rem 0;
`;

export const SwapBudgetItemButton = styled.button`
  border: 0;
  border-radius: ${({ theme }) => theme.borderRadius.md};
  height: 4rem;
  padding: 1rem 2rem;
  transition: ${({ theme }) => theme.transitions.normal};
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  font-size: 1.4rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.white};
  cursor: pointer;
  min-width: 10rem;

  &:disabled {
    cursor: auto;
    opacity: ${({ theme }) => theme.opacity.disabled};
  }

  &:active:not(:disabled) {
    background-color: ${({ theme }) => theme.colors.darkBurgundyRed} !important;
  }

  &:focus-visible {
    outline: 0.3rem solid ${({ theme }) => theme.colors.darkGrey};
  }
`;

export const SwapBudgetItemButtonDeactivate = styled(SwapBudgetItemButton)`
  background-color: ${({ theme }) => theme.colors.lightCoralRed};

  /* Solo con puntero fino: en táctil el :hover se queda pegado tras
     el toque (ver styles/hover.ts). */
  ${hoverCapable} {
    &:hover {
      background-color: ${({ theme }) => theme.colors.lightCoralRed};
      opacity: 0.8;
    }
  }
`;

export const SwapBudgetItemButtonActivate = styled(SwapBudgetItemButton)`
  background-color: ${({ theme }) => theme.colors.green};

  /* Solo con puntero fino: en táctil el :hover se queda pegado tras
     el toque (ver styles/hover.ts). */
  ${hoverCapable} {
    &:hover {
      background-color: ${({ theme }) => theme.colors.green};
      opacity: 0.8;
    }
  }
`;
